// {Componente}{Verbo}{Acción}

// Actualizar la información del cliente
export const TAKER_UPDATE_DATA_REQUEST = 'TAKER_UPDATE_DATA_REQUEST';
export const TAKER_UPDATE_DATA_SUCCESS = 'TAKER_UPDATE_DATA_SUCCESS';
export const TAKER_UPDATE_DATA_ERROR = 'TAKER_UPDATE_DATA_ERROR';

// // Consultar el Cliente a partir del nombre y número de documento
// export const TAKER_RETRIEVE_REQUEST = 'TAKER_RETRIEVE_REQUEST';
// export const TAKER_RETRIEVE_SUCCESS = 'TAKER_RETRIEVE_SUCCESS';
// export const TAKER_RETRIEVE_ERROR = 'TAKER_RETRIEVE_ERROR';

// Crear un cliente a partir del número de documento
export const TAKER_CREATE_REQUEST = 'TAKER_CREATE_REQUEST';
export const TAKER_CREATE_SUCCESS = 'TAKER_CREATE_SUCCESS';
export const TAKER_CREATE_ERROR = 'TAKER_CREATE_ERROR';

// Crea o actualiza un cliente si este ya existe
export const TAKER_CREATE_OR_UPDATE_REQUEST = 'TAKER_CREATE_OR_UPDATE_REQUEST';
export const TAKER_CREATE_OR_UPDATE_SUCCESS = 'TAKER_CREATE_OR_UPDATE_SUCCESS';
export const TAKER_CREATE_OR_UPDATE_ERROR = 'TAKER_CREATE_OR_UPDATE_ERROR';

export const GLOBAL_QUOTATION_RESET_STATE_TAKER = 'GLOBAL_QUOTATION_RESET_STATE_TAKER';
export const GLOBAL_QUOTATION_SET_TAKER_DATA = 'GLOBAL_QUOTATION_SET_TAKER_DATA';
